module.exports = __webpack_public_path__ + "static/media/in_progress.56a26705.svg";